<template>
  <!-- ▼Main Container -->
  <div class="boss-main-container">
    <div class="boss-main-wrap boss-main-content-wrap">
      <setting-header
        :breadcrumbs="[{ name: '求人確認' }]"
        title="掲載済みの求人・応募フォームタイプ設定"
      />
      <section class="margin-top-1">
        <job-publish-section-title title="掲載中の求人情報プレビュー" />
        <job-published-jobs
          :jobs="jobs"
          @updateEntryType="updateEntryType"
        />
      </section>
      <section class="margin-top-1">
        <job-publish-section-title title="掲載中のオプション情報プレビュー" />
        <job-published-options :options="options" />
      </section>
      <!-- 過去の求人情報プレビュー -->
      <job-published-past-jobs
        class="margin-top-1"
        :recent-past-jobs="recentPastJobs"
        :past-jobs="pastJobs"
      />
      <!-- 過去のオプション情報プレビュー -->
      <job-published-past-options
        class="margin-top-1 margin-bottom-3"
        :recent-past-options="recentPastOptions"
        :past-options="pastOptions"
      />
    </div>
  </div>
</template>

<script>
import SettingHeader from '@/components/atoms/SettingHeader'
import JobPublishSectionTitle from '@/components/molecules/JobPublishSectionTitle'
import JobPublishedJobs from '@/components/organisms/JobPublishedJobs'
import JobPublishedOptions from '@/components/organisms/JobPublishedOptions'
import JobPublishedPastJobs from '@/components/organisms/JobPublishedPastJobs'
import JobPublishedPastOptions from '@/components/organisms/JobPublishedPastOptions'
import _ from 'lodash'

export default {
  components: {
    JobPublishedPastJobs,
    JobPublishedPastOptions,
    JobPublishedOptions,
    SettingHeader,
    JobPublishSectionTitle,
    JobPublishedJobs
  },
  data () {
    return {
      jobs: [],
      options: [],
      publishedFolders: []
    }
  },
  computed: {
    jobOptions () {
      return this.publishedFolders.map(v => {
        const date = { startDate: v.startDate, endDate: v.endDate }
        const dateMergedJobs = v.jobs.map(job => {
          return { ...job, ...date }
        })
        const dateMergedOptions = v.options.map(option => {
          return { ...option, ...date }
        })
        return {
          jobs: dateMergedJobs,
          options: dateMergedOptions
        }
      })
    },
    recentPastJobs () {
      return this.jobOptions.filter(v => !_.isEmpty(v.jobs))[0]?.jobs ?? []
    },
    pastJobs () {
      return this.jobOptions.flatMap(v => v.jobs)
    },
    recentPastOptions () {
      return this.jobOptions.filter(v => !_.isEmpty(v.options))[0]?.options ?? []
    },
    pastOptions () {
      return this.jobOptions.flatMap(v => v.options)
    }
  },
  created () {
    this.fetchAll()
  },
  methods: {
    fetchAll () {
      this.fetchPublishJobs()
      this.fetchPublishOptions()
      this.fetchPastJobOptions()
    },
    fetchPublishJobs () {
      this.$http.secured.get('/preview/publish/jobs').then(response => {
        this.$set(this, 'jobs', response.data)
      })
    },
    fetchPublishOptions () {
      this.$http.secured.get('/preview/publish/options').then(response => {
        this.$set(this, 'options', response.data)
      })
    },
    fetchPastJobOptions () {
      this.$http.secured.get('/preview/publish/past_jobs_options').then(response => {
        this.$set(this, 'publishedFolders', response.data)
      })
    },
    updateEntryType (jobId, isSimple) {
      this.$set(this.jobs[this.jobs.findIndex(job => job.id === jobId)], 'isSimple', isSimple)
    }
  }
}
</script>
